module.exports = __webpack_public_path__ + "media/images/pic/meat-2-ef30be3638c4ff1890d40f260720be06.jpg";